import { Navigate } from "react-router-dom";

const isTokenValid = () => {
  const token = localStorage.getItem("authToken");
  const expiry = localStorage.getItem("tokenExpiry");

  if (!token || !expiry) return false;

  return Date.now() < parseInt(expiry); // check if token hasn't expired
};

const PrivateRoute = ({ children }) => {
  return isTokenValid() ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;